import '../shared/types';

/**
 * @typedef {object} LeaderboardState
 * @property {any} data
 */
